import DepreciationEquipmentIcon from './component'

export default DepreciationEquipmentIcon
